$(document).ready(function () {
  $("#application_type").change(function () {
    this.form.submit();
  });
  $("#keyword").change(function (e) {
    $("#keyword_hidden").val($(e.target).val());
  });
});
